var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoQuesAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13222",
    "data-name": "Group 13222",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 100,
    viewBox: "0 0 80 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2813",
    "data-name": "Rectangle 2813",
    width: 80,
    height: 100,
    fill: "#a1a1a1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13221",
    "data-name": "Group 13221",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13060",
    "data-name": "Path 13060",
    d: "M79.971,25.526a5.493,5.493,0,0,0-1.645-3.375l-4.041-3.928L61.257,5.556,57.216,1.627a5.784,5.784,0,0,0-3.471-1.6C53.556.01,53.367,0,53.176,0H5.714A5.637,5.637,0,0,0,0,5.556V94.444A5.637,5.637,0,0,0,5.714,100H74.286A5.637,5.637,0,0,0,80,94.444V26.079a5.482,5.482,0,0,0-.029-.553m-6.16.092a.7.7,0,0,1-.234.047H54.311a.7.7,0,0,1-.709-.689V6.244a.653.653,0,0,1,.048-.227Zm.474,68.826H5.714V5.556H47.929a6.089,6.089,0,0,0-.041.688V24.976a6.336,6.336,0,0,0,6.423,6.244H73.578a6.621,6.621,0,0,0,.708-.04Z",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13061",
    "data-name": "Path 13061",
    d: "M63.486,80.367H52V69.2a2.761,2.761,0,0,0-2.8-2.722h-.116a2.762,2.762,0,0,0-2.8,2.722V80.367H34.8A2.762,2.762,0,0,0,32,83.088V83.2a2.762,2.762,0,0,0,2.8,2.722H46.286V97.09a2.762,2.762,0,0,0,2.8,2.722H49.2A2.761,2.761,0,0,0,52,97.09V85.922H63.486a2.761,2.761,0,0,0,2.8-2.722v-.112a2.761,2.761,0,0,0-2.8-2.722",
    transform: "translate(-9.143 -20.313)",
    fill: "#a1a1a1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoQuesAvailable);
export default __webpack_public_path__ + "static/media/noQuesAvailable.a885ef99b1847c5229fb8608a91d5e68.svg";
export { ForwardRef as ReactComponent };